import { useEffect, useState } from "react";
import TodayIcon from "@mui/icons-material/Today";
import edit from "../../assets/orders/editorder.svg";
import schedule from "../../assets/orders/clock.svg";
import prescription from "../../assets/tasks/Noteform.svg";
import addicon from "../../assets/orders/carbon_add.svg";
import ArticleIcon from "@mui/icons-material/Article";
import { Backdrop, CircularProgress, Switch } from "@mui/material";
import NavButtons from "../nav/navbuttons";
import EditPopup from "../popups/editpopup";
import AddNotesPopup from "../popups/addnotes";
import NewRxPopup from "../popups/newrx";
import api from "../../api/api";
import { useNavigate, useParams } from "react-router-dom";
import LabsNavButtons from "../nav/labsbuttons";
import ProceduresNavButtons from "../nav/procedurebuttons";
import { useDispatch, useSelector } from "react-redux";
import { setSearchResults } from "../../reduxtoolkit/orders/universalsearch";
import ToastMessage from "../../utils/mui/righttoptoast";
import Schedularpopup from "../popups/schedular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import calender from "../../../src/assets/orders/calender.svg";
import AddNoteData from "../../assets/tasks/NoteData.svg";
import { updatelovValue, updateTovValue } from "../../reduxtoolkit/dump";
import {
  collapseIcon,
  expandIcon,
  notesIcon,
  pendingIcon,
  penIcon,
  prescriptionIcon,
  RXIcon,
  scheduledIcon,
  todayIcon,
} from "./svg";
import { COMPLETEDIcon, CROSSIcon } from "../../landingscreen/modals/svgs";
import dayjs from "dayjs";
import OrderCards, { SearchSuggestions } from "../OrderCards";
import { getPracticeId } from "../../config/practice";
const ProcedureTab = ({
  data,
  appointmentId,
  setShowOrders,
  selectedSuggestionList,
  getordersData,
  referals,
  startDate,
  suggestionData,
  fetchsuggestions,
  selectedCard,
  SetSelectedCard,
}) => {
  const [isActive, setIsActive] = useState(false);
  const practiseid = getPracticeId();
  const [activeButton, setActiveButton] = useState(3);
  const [alertmessage, setAlertMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [selectedButtons, setSelectedButtons] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState("t");
  // const [selectedSuggestionList,setSelectedSuggestionList]=useState([])
  // const [suggestionData,setSuggestionsData]=useState([])
  const [isSchedularpopup, setIsSchedularPopUp] = useState(false);
  // const [getordersData,setGetOrdersData]=useState([])
  // const [referals,setReferals]=useState([])
  const dispatch = useDispatch();
  const [isAddnotesPopup, setAddNotesPopup] = useState(false);
  // const [selectedCard,SetSelectedCard]=useState('f')
const params = useParams();

const id = params.id || appointmentId;
const dt = params.dt || startDate;

  const [loading, setLoading] = useState(false);
  const lovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
  );
  const userConfig = useSelector((state) => state.userconfig);
  const tovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
  );
  const lov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov2")?.value
  );
  const tov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov2")?.value
  );
  const [isnewRxpopup, setNewRxPopup] = useState(false);
  const searchResults = useSelector(
    (state) => state.universalsearcher.searchResults
  );
  const [expandedCards, setExpandedCards] = useState({
    today: false,
    scheduled: false,
    prescriptions: false,
    notes: false,
  });

  const toggleCardExpansion = (cardName) => {
    setExpandedCards((prev) => ({
      ...prev,
      [cardName]: !prev[cardName],
    }));
  };

  // Badge count logic
  const todayItems = [
    ...(selectedSuggestionList?.filter((d) => d.schedule === "f") ?? []),
    ...(referals ?? []),
  ];

  // Which statuses count as inactive
  const completedOrCancelled = ["COMPLETED", "CANCELLEDTASK"];

  // Are ALL items inactive?
  const allInactive =
    todayItems.length > 0 &&
    todayItems.every((item) =>
      completedOrCancelled.includes(String(item?.status).toUpperCase())
    );

  // Pending = not completed/cancelled
  const pendingItems = todayItems.filter(
    (item) => !completedOrCancelled.includes(String(item?.status).toUpperCase())&&item.context!== "Tov"
  );

  // Decide the badge number
  const badgeCount = allInactive ? todayItems.length : pendingItems.length;

  // Scheduled items logic
  const scheduledItems =
    selectedSuggestionList?.filter((d) => d.schedule === "t") ?? [];
  const scheduledCompletedOrCancelled = scheduledItems.every((item) =>
    completedOrCancelled.includes(String(item?.status).toUpperCase())
  );
  const scheduledPendingItems = scheduledItems.filter(
    (item) => !completedOrCancelled.includes(String(item?.status).toUpperCase())
  );
  const scheduledBadgeCount =
    scheduledCompletedOrCancelled && scheduledItems.length > 0
      ? scheduledItems.length
      : scheduledPendingItems.length;

  // Prescriptions items logic
  const prescriptionItems = getordersData?.rx_recipe ?? [];
  const prescriptionBadgeCount = prescriptionItems.length; // Prescriptions don't have status, so show all

  // Notes items logic
  const notesItems = getordersData?.notes ?? [];
  const notesBadgeCount = notesItems.length; // Notes don't have status, so show all

  const editalert = (text, sev) => {
    setIsEditPopupOpen(false);
    setSeverity(sev);
    setAlertMessage(text);
    setOpen(true);
    fetchsuggestions();
  };
  const handlealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  //   const fetchsuggestions=async()=>{
  // try {
  //     setLoading(true)
  //     const response =await api.post(`/v1/${practiseid}/orders/get/suggestions`,{
  //         "patientid": data.patientid,
  //         "category": "procedure",
  //         "searchflag":"",
  //         "searchdate": dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0]))
  //         ? dt.split(' ')[0]
  //         : new Date().toISOString().split('T')[0]
  //     })
  //     const selectedsuggestions = await api.post(`/v1/${practiseid}/orders/patient/${data.patientid}/get-orders`, {
  //         "appointmentid": data.appointmentid,
  //         // "orderdate": data.created_at ? new Date(data.created_at).toISOString().split('T')[0] : "Invalid date"
  //          "orderdate": dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0]))
  //          ? dt.split(' ')[0]
  //          : new Date().toISOString().split('T')[0]
  //     });
  //       if (selectedsuggestions.status === 200) {
  //         const suggestionList = selectedsuggestions.data?.look || [];
  //         setGetOrdersData(selectedsuggestions?.data)
  //         setSelectedSuggestionList(suggestionList);
  //         setReferals(selectedsuggestions.data?.referrals || [])
  //       }
  //     if(response.status===200){
  //       setSuggestionsData(response.data)
  //     }else{
  //         setSuggestionsData([])
  //     }
  // } catch (error) {

  // }finally{
  // setLoading(false)

  // }
  // }
  useEffect(() => {
    fetchsuggestions();
  }, [dt]);

  const handleClose = async () => {
    try {
      setLoading(true);
      const response = await api.delete(
        `/v1/${practiseid}/orders/delete/patient/${data.patientid}/notconfirmed`,
        {
          data: {
            // orderdate: data.created_at?new Date(data.created_at).toISOString().split('T')[0]: "Invalid date",
            orderdate:
              dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
                ? dt.split(" ")[0]
                : new Date().toISOString().split("T")[0],
          },
        }
      );
      setTimeout(() => {
        if (appointmentId) {
          dispatch(updatelovValue(data.lov));
          dispatch(updateTovValue(data.tov));
          setShowOrders(false);
        } else {
          navigate("/landing");
        }
      }, 2000);
      //   if (response.status === 200) {
      //     setAlertMessage(response.message)
      // setSeverity("success")
      // setOpen(true)
      //     setTimeout(() => {

      //         navigate('/landing'); // Navigate after 2 seconds
      //     }, 2000);
      // }else{
      //   setAlertMessage(response.message)
      //   setSeverity("info")
      //   setOpen(true)
      // }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      fetchsuggestions();
    }
  };
  const selectsuggestion = async (order) => {
    setLoading(true);
    try {
      const createResponse = await api.post(
        `/v1/${practiseid}/patient/${data.patientid}/orders/create`,
        {
          department_id: 1,
          patient_name: `${data.firstname || ""} ${data.lastname || ""}`.trim(),
          tov: tovValue, // purpose
          lov: lovValue,
          diagnosis: "",
            ordertype: order.context=='diagnosis'?'Diagnostic Tests':order.context, // tabs
          ordername:order.content, // buttons
          schedule: selectedCard, // t/f-schedule
          // provider: data.linked_provider,
          provider: `${userConfig?.firstname || ""} ${userConfig?.lastname || ""}`,
          status: "CREATED",
          confirm_status: "E", // C/E
          // orderdate:  userdata.created_at?new Date(userdata.created_at).toISOString().split('T')[0]: "Invalid date",
        orderdate: dayjs(dt).isValid()
        ? dayjs(dt).format("YYYY-MM-DD")
        : dayjs().format("YYYY-MM-DD"),
          encounterid: 0,
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      dispatch(setSearchResults([]));
      fetchsuggestions();
    }
  };
  // const getorders=async(x)=>{
  //   try {

  //     const selectedsuggestions = await api.post(`/v1/${practiseid}/orders/patient/${data.patientid}/get-orders`, {
  //         "appointmentid": data.appointmentid,
  //         // "orderdate": data.created_at ? new Date(data.created_at).toISOString().split('T')[0] : "Invalid date"
  //          "orderdate": dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0]))
  //          ? dt.split(' ')[0]
  //          : new Date().toISOString().split('T')[0]
  //     });
  //       if (selectedsuggestions.status === 200) {
  //             const lovtovItem = selectedsuggestions?.data?.lovtov?.[0];
  // if(!x){

  // if (lovtovItem) {
  //   dispatch(updatelovValue(lovtovItem.lov));
  //   dispatch(updateTovValue(lovtovItem.tov));
  // } else {
  //   // Optional: set defaults if needed
  //   dispatch(updatelovValue(null));
  //   dispatch(updateTovValue(null));
  // }

  // }

  //         const suggestionList = selectedsuggestions.data?.look || [];
  //         setGetOrdersData(selectedsuggestions?.data)
  //         setSelectedSuggestionList(suggestionList);
  //         setReferals(selectedsuggestions.data?.referrals || [])
  //         return selectedsuggestions?.data
  //       }

  //   } catch (error) {
  //     console.log(error)
  //   }

  // }
  // const handleSave=async()=>{
  //     setLoading(true)
  //     try {

  //          const getorder = await getorders('block');

  // const ordersicd = getorder.diagnosis || [];  // Make sure it's an array

  // const icd10Array = ordersicd.map(item => item.icd10);
  // if(!lovValue){
  //     setAlertMessage('Level of visit is not selected')
  //           setSeverity("info")
  //           setOpen(true)
  // }
  // if(!tovValue){
  //    setAlertMessage('Type of visit is not selected')
  //           setSeverity("info")
  //           setOpen(true)
  // }
  // if(tovValue){
  // if(tovValue===getorder?.lovtov[0]?.tov&&lovValue===getorder?.lovtov[0]?.lov){
  // }else{
  //     await api.put(`/v1/${practiseid}/patient/${data.patientid}/orders/lovtov/update`,{
  //           patientname: `${data.firstname || ''} ${data.lastname || ''}`.trim(),
  //       orderdate:
  //                             dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0]))
  //                                 ? dt.split(' ')[0]
  //                                 : new Date().toISOString().split('T')[0],
  //   "lov": lovValue,
  //   "ordlist": tovValue,
  //   "task": "VISIT",
  //   "loginuser": userConfig?.username,
  //   "user_role": "ALL"
  //   })

  // }

  // }else{
  //  const createResponse = await api.post(
  //                     `/v1/${practiseid}/patient/${data.patientid}/orders/create`,
  //                     {
  //                         department_id: 1,
  //                         patient_name: `${data.firstname || ''} ${data.lastname || ''}`.trim(),
  //                         tov: tovValue, // purpose
  //                         lov: data.lov,
  //                         diagnosis: '',
  //                         ordertype: 'VISIT', // tabs
  //                         ordername: ' ', // buttons
  //                         schedule: selectedCard, // t/f-schedule
  //                         provider: data.linked_provider,
  //                         status: 'CREATED',
  //                         confirm_status: 'E', // C/E
  //                         orderdate:
  //                             dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0]))
  //                                 ? dt.split(' ')[0]
  //                                 : new Date().toISOString().split('T')[0],
  //                         encounterid: 0,

  //                     }
  //                 )
  // }
  // if (
  //   tov2Value !== getorder?.lovtov[0]?.tov2 ||
  //   lov2Value !== getorder?.lovtov[0]?.lov2
  // ) {
  //   // only update if tov2Value exists
  //   tov2Value &&
  //     await api.put(
  //       `/v1/${practiseid}/orders/update/patient/${data.patientid}/secondtovtask`,
  //       {
  //         task: "VISIT",
  //         orderdate:
  //           dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
  //             ? dt.split(" ")[0]
  //             : new Date().toISOString().split("T")[0],
  //         lov2: lov2Value,
  //         tov2: tov2Value,
  //       }
  //     );
  // } else {
  //   // both values are same, do nothing
  //   console.log("No update needed, values unchanged.");
  // }
  //         const response= await api.post(`/v1/${practiseid}/patient/${data.patientid}/orders/confirm`,{
  //             "patient_name": `${data.firstname || ''} ${data.lastname || ''}`.trim(),
  //          "createdby": userConfig?.username||'',
  //             // "orderdate": data.created_at?new Date(data.created_at).toISOString().split('T')[0]: "Invalid date",
  //              "orderdate":dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0]))
  //              ? dt.split(' ')[0]
  //              : new Date().toISOString().split('T')[0],
  //             "tov":tovValue,
  //             "lov":lovValue,
  //                diagnosis:icd10Array,
  //             "appointmentid":data.appointmentid,
  //             "token_no": 0,
  //             "confirm_status": "E",
  //             "update_status": "C"
  //           })
  //           if (response.status === 200) {
  //             setAlertMessage(response.message)
  //         setSeverity("success")
  //         setOpen(true)
  //             setTimeout(() => {

  //         if(appointmentId){
  // setShowOrders(false)
  //               }else{
  //               navigate('/landing');
  //               }
  //             }, 2000);
  //         }else{
  //           setAlertMessage(response.message)
  //           setSeverity("info")
  //           setOpen(true)
  //         }
  //     } catch (error) {

  //     }finally{
  // setLoading(false)
  //     }
  // }

  return (
    <>
      <div className="bmor bmor-pick-body">
      <ProceduresNavButtons
        selectedCard={selectedCard}
        userdata={data}
        data={suggestionData}
             dt={dt}
        selectedSuggestionList={selectedSuggestionList}
        fetchsuggestions={fetchsuggestions}
        loading={loading}
        getordersData={getordersData}
                appointmentId={appointmentId}
        startDate={startDate}
      />
      <SearchSuggestions results={searchResults} onPick={selectsuggestion} />
      </div>


      <OrderCards
        selectedSuggestionList={selectedSuggestionList}
        referals={referals}
        getordersData={getordersData}
        selectedCard={selectedCard}
        SetSelectedCard={SetSelectedCard}
        onEdit={(which) => {
          setSelectedEdit(which);
          setIsEditPopupOpen(true);
        }}
        onAddRx={() => setNewRxPopup(true)}
        onAddNote={() => setAddNotesPopup(true)}
        onScheduleProcedure={() => setIsSchedularPopUp(true)}
      />

      {/* <div className="w-full flex justify-end gap-4 sm:gap-4 mt-4">

                    <button
                    onClick={()=>handleClose()}
                        className="rounded w-[100px] bg-white cursor-pointer text-black border-[1.5px] border-gray-200 py-1 px-3 transition duration-300 ease-in-out  hover:bg-gray-800">
                        Close
                    </button>

                    <button
onClick={()=>handleSave()}
                        className="rounded w-[100px] bg-black text-white py-1 px-3 bg-[#1E2A4A] transition duration-300 ease-in-out hover:bg-gray-800">
                        Save
                    </button>
                </div> */}
      <EditPopup
        userdata={data}
        fetchsuggestions={fetchsuggestions}
        selectedEdit={selectedEdit}
        editalert={editalert}
        isOpen={isEditPopupOpen}
        onClose={() => setIsEditPopupOpen(false)}
        getordersData={getordersData}
        dt={dt}
      />
      <AddNotesPopup
        fetchsuggestions={fetchsuggestions}
        userdata={data}
        isOpen={isAddnotesPopup}
        onClose={() => setAddNotesPopup(false)}
        dt={dt}
      />
      <NewRxPopup
        fetchsuggestions={fetchsuggestions}
        userdata={data}
        dt={dt}
        isOpen={isnewRxpopup}
        onClose={() => setNewRxPopup(false)}
      />
      <Schedularpopup
        isOpen={isSchedularpopup}
        onClose={setIsSchedularPopUp}
        data={data}
      />
      <Backdrop
        sx={{
          color: "secondary.main", // Sets the CircularProgress color to secondary
          backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent white background
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={loading}
      >
        <CircularProgress color="secondary" />
      </Backdrop>
      <ToastMessage
        message={alertmessage}
        severity={severity}
        open={open}
        handleClose={handlealert}
      />
    </>
  );
};
export default ProcedureTab;
